import { ImportHeader } from "import/containers";
import { ImportWeight } from "components/Import";
import { Header, PageContent, PageHeader, Spacer } from "components";

export const ImportExternal = () => (
  <>
    <PageHeader>
      <Header title="Import livestock data" />
    </PageHeader>

    <PageContent>
      <Spacer baselineHeight={3} />

      <ImportHeader text="Import from supported systems" />

      <ImportWeight />
    </PageContent>
  </>
);
